// columnTypes.js — maps a domain column "type" to how it renders + which filter widget it uses.
// Behaviors live here (code), never in the JSON config.
import React from "react";
import { format, parseISO } from "date-fns";
import TextFilter from "./filters/TextFilter";
import NumberRangeFilter from "./filters/NumberRangeFilter";
import DateRangeFilter from "../DateRangeFilter";
import SelectFilter from "../SelectFilter";

function renderDate(value) {
   if (!value) return "N/A";
   try {
      return format(parseISO(value), "yyyy-MM-dd");
   } catch {
      return "Invalid date";
   }
}

function renderCurrency(value) {
   const n = Number(value);
   if (value == null || value === "" || Number.isNaN(n)) return "";
   return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

function renderEnum(value, _row, col) {
   const opt = (col?.enumValues || []).find((o) => String(o.value) === String(value));
   return opt ? opt.label : value ?? "";
}

export const columnTypes = {
   string: { align: "left", renderCell: (v) => (v == null ? "" : v), FilterComponent: TextFilter },
   number: { align: "right", renderCell: (v) => (v == null || v === "" ? "" : v), FilterComponent: NumberRangeFilter },
   currency: { align: "right", renderCell: renderCurrency, FilterComponent: NumberRangeFilter },
   date: { align: "left", renderCell: renderDate, FilterComponent: DateRangeFilter },
   term: { align: "right", renderCell: (v) => (v == null || v === "" ? "" : `Net ${v}`), FilterComponent: NumberRangeFilter },
   enum: { align: "left", renderCell: renderEnum, FilterComponent: SelectFilter },
   boolean: { align: "center", renderCell: (v) => (v ? "Yes" : "No"), FilterComponent: SelectFilter },
};

export function getColumnType(type) {
   return columnTypes[type] || columnTypes.string;
}
